@if (collapsed()) {
    @if (item().subItems) {
        <a class="side-nav__item collapsed" [class]="itemClasses(item())" mat-list-item [routerLink]="item().route" [matMenuTriggerFor]="menu">
            @if (item().icon) {
                <div class="side-nav__icon side-nav__icon--collapsed" matListItemIcon>
                    <img [ngSrc]="'/assets/img/' + item().icon + '.svg'" alt="" fill />
                </div>
            }
        </a>

        <mat-menu #menu="matMenu" class="side-nav__menu-panel">
            @for (subItem of item().subItems; track subItem) {
                <a mat-menu-item [disableRipple]="true" [routerLink]="subItem.route" (click)="routeClick()">
                    {{ subItem.label | translate }}
                </a>
            }
        </mat-menu>
    } @else {
        <a class="side-nav__item collapsed" [class]="itemClasses(item())" mat-list-item [routerLink]="item().route!" (click)="routeClick()">
            @if (item().icon) {
                <div class="side-nav__icon side-nav__icon--collapsed" matListItemIcon>
                    <img [ngSrc]="'/assets/img/' + item().icon + '.svg'" alt="" fill />
                </div>
            }
        </a>
    }
} @else {
    <a
        mat-list-item
        class="side-nav__item"
        [class]="itemClasses(item())"
        [routerLink]="item().route"
        [attr.aria-expanded]="item().subItems ? nestedMenuOpen() : null"
        (click)="unCollapedClick()"
    >
        @if (item().icon) {
            <div class="side-nav__icon" matListItemIcon>
                <img [ngSrc]="'/assets/img/' + item().icon + '.svg'" alt="" fill />
            </div>
        }

        <span [class.side-nav__label]="level() === 0" [class.ps-5]="level() > 0" [class.side-nav-subNav__label]="level() >= 1" matListItemTitle>
            {{ item().label | translate }}
        </span>

        @if (item().subItems) {
            <span matListItemMeta>
                <img
                    class="side-nav__arrow"
                    [class]="{ 'side-nav__arrow--open': nestedMenuOpen(), 'pe-2': nestedMenuOpen(), 'ps-2': !nestedMenuOpen() }"
                    src="/assets/img/caret-down.svg"
                    alt=""
                />
            </span>
        }
    </a>

    @if (item().subItems && nestedMenuOpen()) {
        @for (subItem of item().subItems; track subItem.label) {
            <side-nav-menu [item]="subItem" [collapsed]="collapsed()" [level]="level() + 1" />
        }
    }
}
